import {
  CREATETODO,
  GETALLDEPARTMENTBYCOMPANYID,
  GETMANAGETODO,
  GETUSERSBYDEPARTMENTID,
  GETVALIDATIONAPIID,
  GET_TODO_CONTROLS,
  GET_ACTIVITY_DATA_WITH_CUSTOMFIELD,
  GET_ALL_ACTIVITY_WITH_CUSTOM_FIELD,
  GET_ACTIVITY_DATA_FOR_ONBOARDING,
  RESET_REDUX_STATE,
  SET_RETAIN_PROPS,
  SET_TODO_NOTIFICATION_DATA,
  SET_TODO_DATA_BY_TODO_ID,
  GET_DEFAULT_MASTER_TODOS,
  SET_PARENT_TODO_ID_FOR_COPY,
  SET_TODO_DATA_FOR_UPDATE_INVENTORY,
  CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY,
  SET_TODO_FIELD_LIST
} from "../constants";

const initState = {
  todoList: [],
  todoDepartmentList: [],
  todoUsersList: [],
  todoValidationApiId: [],
  newtododata: "",
  todoControlList: [],
  activityListForCards: [],
  activityResponse: [],
  allActivityResponse: [],
  allCard: [],
  activityDataForOnboarding: [],
  retainpropsdata: false,
  todoNotificationData: [],
  todoDataByToDoId: "",
  defaultMasterToDos: [],
  parentToDoIdForCopy: "",
  todoDataForUpdateInventory: "",
  todoFieldList: []
};

const todo = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GETMANAGETODO: {
      return {
        ...state,
        todoList: payload,
      };
    }
    case GETALLDEPARTMENTBYCOMPANYID: {
      return {
        ...state,
        todoDepartmentList: payload,
      };
    }
    case GETUSERSBYDEPARTMENTID: {
      return {
        ...state,
        todoUsersList: payload,
      };
    }
    case GETVALIDATIONAPIID: {
      return {
        ...state,
        todoValidationApiId: payload,
      };
    }
    case CREATETODO: {
      return {
        ...state,
        newtododata: payload.data.id,
      };
    }
    case GET_TODO_CONTROLS: {
      return {
        ...state,
        todoControlList: payload,
      };
    }

    case GET_ACTIVITY_DATA_WITH_CUSTOMFIELD: {
      return {
        ...state,
        activityListForCards: payload,
        activityResponse: payload,
      };
    }

    case GET_ALL_ACTIVITY_WITH_CUSTOM_FIELD: {
      return {
        ...state,
        allActivityResponse: payload,
        allCard: payload,
      };
    }

    case GET_ACTIVITY_DATA_FOR_ONBOARDING: {
      return {
        ...state,
        activityDataForOnboarding: payload,
      };
    }

    case SET_RETAIN_PROPS: {
      return {
        ...state,
        retainpropsdata: payload,
      };
    }

    case SET_TODO_NOTIFICATION_DATA: {
      return {
        ...state,
        todoNotificationData: payload,
      };
    }

    case RESET_REDUX_STATE: {
      return initState;
    }

    case SET_TODO_DATA_BY_TODO_ID: {
      return {
        ...state,
        todoDataByToDoId: payload,
      };
    }

    case GET_DEFAULT_MASTER_TODOS: {
      return {
        ...state,
        defaultMasterToDos: payload,
      };
    }

    case SET_PARENT_TODO_ID_FOR_COPY: {
      return {
        ...state,
        parentToDoIdForCopy: payload
      }
    }

    case SET_TODO_DATA_FOR_UPDATE_INVENTORY: {
      return {
        ...state,
        todoDataForUpdateInventory: payload
      }
    }

    case CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY: {
      return {
        ...state,
        todoDataForUpdateInventory: ""
      }
    }

    case SET_TODO_FIELD_LIST: {
      return {
        ...state,
        todoFieldList: payload
      }
    }

    default:
      return state;
  }
};

export default todo;
